import { render } from "./PaywallSharedAccess.vue?vue&type=template&id=3980b97e"
import script from "./PaywallSharedAccess.vue?vue&type=script&setup=true&lang=js"
export * from "./PaywallSharedAccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Paywall/PaywallSharedAccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3980b97e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3980b97e', __exports__)) {
    api.reload('3980b97e', __exports__)
  }
  
  module.hot.accept("./PaywallSharedAccess.vue?vue&type=template&id=3980b97e", () => {
    api.rerender('3980b97e', render)
  })

}


export default __exports__